import { LeaderboardFilters } from "./filters";

export function Leaderboard({ theme, setTheme }) {
	return (
		<>
			<LeaderboardFilters theme={theme} setTheme={setTheme} />
		</>
	)
};
